<template>
  <div>
    <b-modal
      id="create-contract-modal"
      size="lg"
      title="Luo keikkasopimus"
      centered
      cancel-variant="outline-secondary"
      cancel-title="Peru"
      :no-close-on-backdrop="true"
      @show="onModalOpen"
    >
      <validation-observer ref="contractRules">
        <b-form ref="form" @submit.stop.prevent="handleSubmit">
          <b-row>
            <b-col lg="6">
              <b-form-group label="Etunimi" label-for="firstName">
                <validation-provider #default="{ errors }" name="Etunimi" rules="required">
                  <b-form-input
                    id="firstName"
                    v-model="form.firstName"
                    style="text-transform: capitalize"
                    placeholder="Etunimi"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Sukunimi" label-for="lastName">
                <validation-provider #default="{ errors }" name="Sukunimi" rules="required">
                  <b-form-input
                    id="lastName"
                    v-model="form.lastName"
                    style="text-transform: capitalize"
                    placeholder="Sukunimi"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-form-group label="Sähköposti" label-for="email">
                <validation-provider #default="{ errors }" name="Sähköposti" rules="required|email">
                  <b-form-input
                    id="email"
                    v-model="form.email"
                    type="email"
                    placeholder="Sähköposti"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Puhelin" label-for="phone">
                <validation-provider #default="{ errors }" name="Puhelin" rules="required">
                  <b-form-input
                    id="phone"
                    v-model="form.phone"
                    type="number"
                    placeholder="Puhelin"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="8">
              <b-form-group label="Osoite" label-for="address">
                <validation-provider #default="{ errors }" name="Osoite" rules="required">
                  <b-form-input id="address" v-model="form.address" placeholder="Osoite" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Kaupunki" label-for="city">
                <validation-provider #default="{ errors }" name="Kaupunki" rules="required">
                  <b-form-input id="city" v-model="form.city" placeholder="Kaupunki" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-form-group label="IBAN" label-for="IBAN">
                <validation-provider #default="{ errors }" name="IBAN" rules="required">
                  <b-form-input id="IBAN" v-model="form.IBAN" placeholder="IBAN" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="HETU" label-for="HETU">
                <validation-provider #default="{ errors }" name="HETU" rules="required">
                  <b-form-input id="HETU" v-model="form.prsID" placeholder="HETU" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer="{cancel}">
        <b-button variant="outline-secondary" @click="cancel()">
          Peru
        </b-button>
        <b-button variant="primary" @click.prevent="e => handleCreate(e)">
          Luo ja lähetä
        </b-button>
      </template>
    </b-modal>
    <b-card title="Sopimuksen tila:">
      <div v-if="!checkingContractStatus">
        <div v-if="contractStatus === 'signed'">
          <h6 class="card-subtitle text-muted mb-2">
            Työntekijä on allekirjoittanut sopimuksen.
          </h6>
        </div>
        <div v-else-if="contractStatus === 'pending'">
          <h6 class="card-subtitle text-muted mb-2">
            Sopimus lähetetty työntekijälle allekirjoitettavaksi.
          </h6>
        </div>
        <div v-else>
          <h6 class="card-subtitle text-muted mb-2">
            Työntekijällä ei ole sopimusta viellä.
          </h6>
          <!--<b-button
            v-b-modal.create-contract-modal
            variant="info"
            :disabled="creatingContract"
            block
          >
            <b-spinner v-if="creatingContract" small />
            <span v-if="!creatingContract">
              Luo Sopimus
            </span>
          </b-button>-->
        </div>
      </div>
      <div
        v-if="checkingContractStatus"
        style="flex: 1; justify-content: center; align-items: center; text-align: center"
      >
        <b-spinner large />
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BCol,
  BRow,
  BButton,
  VBModal,
  BForm,
  BFormGroup,
  BFormInput,
  BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import store from '@/shared/store'
import router from '@/shared/router'

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export default {
  components: {
    BCol,
    BRow,
    BCard,
    BButton,
    BForm,
    BSpinner,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    processer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      creatingContract: false,
      checkingContractStatus: false,
      contractStatus: 'no_contract',
      form: {
        firstName: '',
        lastName: '',
        email: '',
        IBAN: '',
        prsID: '',
        address: '',
        city: '',
        phone: '',
      },
    }
  },
  mounted() {
    if (
      this.userData.workContract &&
      !this.userData.workContract.signed &&
      this.userData.workContract.documentUuid
    ) {
      this.checkingContractStatus = true
      store
        .dispatch('appApplications/getContractStatus', {
          userId: router.currentRoute.params.id,
        })
        .then(({ status }) => {
          this.checkingContractStatus = false
          if (status === 'pending') {
            this.contractStatus = 'pending'
          }
          if (status === 'signed') {
            this.contractStatus = 'signed'
          }
        })
        .catch(() => {
          this.checkingContractStatus = false
        })
    } else if (
      !this.userData.workContract ||
      (!this.userData.workContract.signed && !this.userData.workContract.documentUuid)
    ) {
      this.contractStatus = 'no_contract'
    } else {
      this.contractStatus = 'signed'
    }
  },
  methods: {
    onModalOpen() {
      this.form.firstName = this.userData.firstName
      this.form.lastName = this.userData.lastName
      this.form.email = this.userData.email
      this.form.phone = this.userData.mobile
      this.form.address = this.userData.address.streetAddress
      this.form.city = this.userData.address.city
    },
    handleCreate(e) {
      if (this.$refs.contractRules.flags.invalid) {
        e.preventDefault()
      }
      this.handleSubmit()
    },
    handleSubmit() {
      this.$refs.contractRules.validate().then(async success => {
        if (success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sopimusta luodaan..',
              icon: 'UserIcon',
              variant: 'info',
            },
          })
          this.createContractSignatureRequest()
          this.$bvModal.hide('create-contract-modal')
        }
      })
    },
    async createContractSignatureRequest() {
      this.creatingContract = true
      const user = {
        name: `${capitalize(this.form.firstName)} ${capitalize(this.form.lastName)}`,
        email: this.form.email,
        phone: this.form.phone,
        IBAN: this.form.IBAN,
        prsID: this.form.prsID,
        address: `${capitalize(this.form.address)} ${capitalize(this.form.city)}`,
      }
      const date = new Date().toLocaleDateString('fi')
      const contractName = `${user.name}_Työsopimus_${date}`
      try {
        const result = await store.dispatch('appApplications/createContract', {
          user,
        })
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Lähetetään allekirjoitus kutsu...',
            icon: 'MailIcon',
            variant: 'info',
          },
        })
        const url = result.documentPath
        const contractInfo = {
          email: user.email,
          documentPath: url,
          documentName: contractName,
          userId: this.userData.id,
          processer: this.processer,
        }
        await store.dispatch('appApplications/requestContractSignature', {
          contractInfo,
        })
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sopimus luotu ja lähetetty',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.creatingContract = false
        this.contractStatus = 'pending'
      } catch (e) {
        this.creatingContract = false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sopimusta ei voitu luoda.',
            icon: 'AlertCircle',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>
